<template lang="html">
  <div>
    <div class="row">
      <div class="col-md-6">
        <button type="button" @click="getFixtures" class="btn btn-primary">Generar</button>
      </div>
      <div class="col-md-6">
        <button type="button" @click="downloadFixtures" class="btn btn-primary">Descargar</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h3>Salidas ({{ totalLines }} grupos)</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div  class="col-md-6" v-for="line in fixtureData">
          <strong>Salida {{ $index +1 }}</strong>
          <ul class="list-group" v-sortable="lineOptions($index)">
              <li v-for="player in line.players | orderBy 'score'" class="list-group-item" id="{{player.id}}">
                <span class="flag-icon flag-icon-{{player.country | lowercase}}"></span>
                {{ player.surname }} {{ player.name}}
                ({{ player.score }})
              </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fixture from '../api/fixture'
import JSONtoCsv from '../utils/jsontocsv'
import {
  getCurrentChampionship,
  getCurrentCourse,
  getCurrentDate
} from '../vuex/getters'
import * as actions from '../vuex/actions'
export default {
  vuex: {
    getters: {
      championship: getCurrentChampionship,
      current_date: getCurrentDate,
      course: getCurrentCourse
    }
  },
  data() {
    return {
      categorySelected: '',
      fixture: [],
      fixtureData: [],
      dateSelected: null
    };
  },
  computed: {
    totalLines() {
      return this.fixtureData.length
    },
    allGroups() {
      let groups = []
      for (let i = 0; i < this.totalLines; i++) {
        let group = 'group' + i
        groups.push(group)
      }
      return groups
    }
  },
  methods: {
    selectDate(date) {
      this.dateSelected = date
    },
    getFixtures() {
      this.$progress.start()
      let FixtureApi = new Fixture()
      let fixtureDataPost = {
        championship_id: this.championship.id,
        course_id: this.course.id
      }
      FixtureApi.generate(fixtureDataPost).then(response => {
        this.fixtureData = response.data
        this.$progress.finish()
      }, error => {
        console.log(error)
        this.$progress.failed()
      })
    },
    downloadFixtures() {
      JSONtoCsv(this.fixtureData, 'Fixture_' + this.course.name, false)
    },
    lineOptions(id) {
      let FixtureApi = new Fixture()
      return {
        animation: 250,
        ghostClass: 'ghost',
        dataIdAttr: 'data-id',
        group: {
          name: 'group' + id,
          put: this.allGroups
        },
        onAdd: (evt) => {
          let item = evt.item
          console.log('agrega player' + item.id + ' al grupo ' + id)
        },
        onUpdate: (evt) => {
          let item = evt.item
          console.log('actualiza orden de ' + item.id + ' en grupo ' + id)
        },
        onRemove: (evt) => {
          let item = evt.item
          console.log('elimima player ' + item.id + ' desde grupo ' + id)
        }
      }
    }
  },
  components: {}
};
</script>

<style lang="css">
.ghost {
  opacity: .5;
  background: #C8EBFB;
}
</style>



/** WEBPACK FOOTER **
 ** Fixtures.vue?54135766
 **/